import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/otrosEquipos/EquipoLlenadoTanque/LenadoTanque1.png';
import Img2 from '../../img/products/otrosEquipos/EquipoLlenadoTanque/LenadoTanque2.png';

const EquipoLlenadoTanque = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Equipo Llenado de Tanque (Bajo-Alto) </h2>
      <div className="row align-items-start mb-5">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Llenado Tanque 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Llenado Tanque 2" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            El equipo de bombeo para el llenado de un tanque bajo a un tanque alto es una solución eficiente 
            para asegurar un suministro constante de agua en sistemas de almacenamiento y distribución. 
            Este tipo de equipo es ideal para aplicaciones en edificios residenciales, comerciales, industriales y agrícolas.
          </p>
          <p className="lead text-justify">
            Utiliza bombas de alta capacidad para elevar el agua desde el tanque bajo hasta el tanque alto y está equipado 
            con sensores de nivel que monitorean el nivel de agua en ambos tanques y ajustan el funcionamiento de la bomba 
            en consecuencia. También ajusta la velocidad de la bomba según la demanda de agua, optimizando el consumo de energía.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EquipoLlenadoTanque;
